import { useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HomePage from '@/pages';
import CapabilitiesPage from '@/pages/capabilities';
import IndustriesPage from '@/pages/industries';
import ManufacturingPage from '@/pages/manufacturing';
import TeamPage from '@/pages/team';
import AboutPage from '@/pages/about';
import ContactPage from '@/pages/contact';
import ScrollToHash from '@/components/ScrollToHash';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    ScrollTrigger.defaults({ once: true });
  }, []);

  return (
    <HashRouter>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/capabilities" element={<CapabilitiesPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/manufacturing" element={<ManufacturingPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
